// ═══════════════════════════════════════════════════════
// ULTIMAZE TOWER WARS — NoopNotificationAdapter
// Phase 1-3 placeholder — all calls are silent no-ops
// ═══════════════════════════════════════════════════════

import type { INotificationService } from '../interfaces';

export class NoopNotificationAdapter implements INotificationService {
  requestPermission(): Promise<boolean> {
    return Promise.resolve(false);
  }

  scheduleLocal(_opts: { title: string; body: string; atDate: Date }): Promise<void> {
    return Promise.resolve();
  }

  cancelAll(): Promise<void> {
    return Promise.resolve();
  }
}
